<template>
  <div class="bd3Command">
    <div class="title">在线协议解析工具</div>
    <div class="flex-start mb_10 mt_10">
      <div>协议类型： </div>
      <el-select v-model="value" placeholder="请选择">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <el-input class="mt_20" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" placeholder="请选择内容"
      v-model="textareaValue">
    </el-input>

    <div class="flex-start mt_20">
      <el-button type="primary" @click="commandAnalysis">解析</el-button>
      <el-button @click="deltext">清空</el-button>
    </div>

    <div id="analysisShow" class="mt_20 mt_30"></div>
  </div>
</template>

<script>
import tdwtClass from '@/utils/analysis/tdwt.js';
import bd3Class from '@/utils/analysis/bd3.js';
import { mapActions } from 'vuex';
import { GB18030StringZh } from '@/utils/analysis/global.js';
export default {
  name: 'bd3test',
  data() {
    return {
      options: [
        { value: 'dbAm', label: '北斗协议' },
        { value: 'tdwtAm', label: '天地卫通协议' },
        // { value: '808Am', label: '808协议' },
        // { value: 'bluetooth', label: '蓝牙盒子协议' }
      ],
      value: 'dbAm',
      textareaValue: ""
    };
  },
  components: {
  },
  methods: {
    ...mapActions(['setBg']),
    commandAnalysis() {
      try {
        const agreementType = this.value;
        if (agreementType == 'tdwtAm') {
          this.commandTdwtAgreement();
          return;
        }
        this.commandSet();
      } catch (error) {
        console.error("error==>",error);
      }
    },
    commandSet() {
      document.querySelector("#analysisShow").innerHTML = '';
      let trimmedStr = this.textareaValue;
      // const charCode = trimmedStr.replace(/\s+/g, '');
      const charCode = trimmedStr.replace(/^\s+|\s+$/g, ''); 
      const instructArr = charCode.split(",");
      const code = instructArr[0];
      // 在这里处理该指令
      let analysisHTML = '';
      if (code) {
        switch (code) {
          case "$CCTCQ": //天地卫通协议v1.3.9
            // let mySeleType = document.getElementById("mySelect").value;
            // const codingType = instructArr[4];
            let tdwtData = charCode;
            // if (mySeleType == '16be' && (codingType == 1 || codingType == 4)) {
            //   let hexString = stringToHex(charCode);
            //   tdwtData = GB18030StringZh(hexString);
            // }
            analysisHTML = tdwtClass.commandTdwt(tdwtData);
            break;
          default:
            analysisHTML = bd3Class.commandbd3(charCode);
            // alert("数据错误或未记录该命令");
            break;
        }
      }
      document.querySelector("#analysisShow").innerHTML = analysisHTML;
    },
    commandTdwtAgreement() {
      const trimmedStr = this.textareaValue;
      const tdwtData = trimmedStr.replace(/^\s+|\s+$/g, ''); 
      let analysisHTML = tdwtClass.communicationData(tdwtData, 2);
      document.querySelector("#analysisShow").innerHTML = analysisHTML;
    },
    deltext() {
      this.textareaValue = '';
      document.querySelector("#analysisShow").innerHTML = '';
    }
  },
  created() {
    this.setBg(this.$route.meta.showBg);
  },
};
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
.bd3Command {
  width: 1000px;
  margin: 0 auto;
  margin-top: 48px;

  &::v-deep {
    .mb_10 {
      margin-bottom: 10px;
    }

    .mb_20 {
      margin-bottom: 20px;
    }

    .mt_10 {
      margin-top: 10px;
    }

    .mt_20 {
      margin-top: 20px;
    }

    .ml_10 {
      margin-left: 10px;
    }

    .ml_20 {
      margin-left: 20px;
    }
  }

  .title {
    width: 100%;
    text-align: center;
    font-size: 24px;
    height: 52px;
    line-height: 52px;
  }

  div {
    line-height: 28px;
  }
}
</style>